import React from 'react';
import CloseButton from '../../../../../components/CloseButton/CloseButton';
import { getOptimalTextColor } from '../../../../../utils/colorHelper';
import cx from 'classnames';
import styles from './TagsList.module.scss';

const TagsList = ({ tags, size = 'medium', onRemove }) => {
  return tags.map(item => (
    <li
      key={item.id}
      tabIndex={0}
      aria-label={item.name}
      style={{ backgroundColor: item.color }}
      className={cx(styles.tagItem, styles[size], { [styles.noBackground]: item.color === '#ffffff' })}
    >
      <span className={styles.name} style={{ color: getOptimalTextColor(item.color) }}>
        #{item.name}
      </span>
      {onRemove && (
        <CloseButton
          variant="outline"
          onClose={() => {
            console.log('TagsList onRemove', item.id);
            onRemove(item.id);
          }}
        />
      )}
    </li>
  ));
};

export default TagsList;
